export const ConstrucaoIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.94517 8.88215L4.21864 16.3801C4.10801 16.6844 4.18362 17.0252 4.41256 17.2541C4.64149 17.4831 4.98231 17.5587 5.28658 17.448L12.7845 14.7215C13.0522 14.6242 13.2516 14.3969 13.3133 14.1188C13.375 13.8408 13.2904 13.5505 13.089 13.3491L8.31755 8.57769C8.11616 8.37631 7.82587 8.29173 7.54783 8.35341C7.26979 8.4151 7.04251 8.6145 6.94517 8.88215Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4775 8.14408L15.394 4.22748C15.9799 3.64165 15.9799 2.69183 15.394 2.106V2.106C15.1127 1.82467 14.7312 1.66663 14.3333 1.66663C13.9355 1.66663 13.5539 1.82467 13.2726 2.106L9.94525 5.43332C9.61981 5.75875 9.61981 6.28639 9.94525 6.61182L11.4775 8.14408Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.94523 6.61182L11.9108 8.57741C12.0671 8.73369 12.1549 8.94565 12.1549 9.16667C12.1549 9.38768 12.0671 9.59964 11.9108 9.75592L9.16675 12.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
